.mealIngredients {
  display: flex;
  flex-direction: column;
  padding-left: 0px;
}
.mealIngredients .mealPicIngredients {
  display: flex;
  flex-flow: row wrap;
}
.mealIngredients .mealPicIngredients .mealShow {
  flex: 1 auto;
}
.mealIngredients .mealNotes {
  font-size: 12px;
  margin-bottom: 8px;
}
.mealIngredients .mealNotes .memoLine {
  margin-bottom: 6px;
}
.mealIngredients table {
  margin-bottom: 0px;
}
.mealIngredients table td.amount {
  white-space: nowrap;
  text-align: right;
}
.mealIngredients .mealTimeline {
  margin-top: 12px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lYWxJbmZvLnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBOztBQUNBO0VBQ0U7O0FBQ0o7RUFDRTtFQUNBOztBQUNBO0VBQ0U7O0FBQ0o7RUFDRTs7QUFDQTtFQUNFO0VBQ0E7O0FBQ0o7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi5tZWFsSW5ncmVkaWVudHNcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uXG4gIHBhZGRpbmctbGVmdDogMHB4XG4gIC5tZWFsUGljSW5ncmVkaWVudHNcbiAgICBkaXNwbGF5OiBmbGV4XG4gICAgZmxleC1mbG93OiByb3cgd3JhcFxuICAgIC5tZWFsU2hvd1xuICAgICAgZmxleDogMSBhdXRvXG4gIC5tZWFsTm90ZXNcbiAgICBmb250LXNpemU6IDEycHhcbiAgICBtYXJnaW4tYm90dG9tOiA4cHhcbiAgICAubWVtb0xpbmVcbiAgICAgIG1hcmdpbi1ib3R0b206IDZweFxuICB0YWJsZVxuICAgIG1hcmdpbi1ib3R0b206IDBweFxuICAgIHRkLmFtb3VudFxuICAgICAgd2hpdGUtc3BhY2U6IG5vd3JhcFxuICAgICAgdGV4dC1hbGlnbjogcmlnaHRcbiAgLm1lYWxUaW1lbGluZVxuICAgIG1hcmdpbi10b3A6IDEycHhcbiJdfQ== */